import React, { useEffect } from 'react';
import { styles } from './styles.js';

const DEFAULT_COLOR_SCHEME = 'light';
const STYLE_SHEET_ID = 'polaris-custom-properties';
function CustomProperties(props) {
  const {
    as: Component = 'div',
    children,
    className,
    colorScheme = DEFAULT_COLOR_SCHEME
  } = props;
  useEffect(() => {
    let styleSheet = document.getElementById(STYLE_SHEET_ID);
    if (styleSheet) return;
    styleSheet = document.createElement('style');
    styleSheet.id = STYLE_SHEET_ID;
    styleSheet.textContent = styles;
    document.head.appendChild(styleSheet);
  }, []);
  return /*#__PURE__*/React.createElement(Component, {
    "p-color-scheme": colorScheme,
    className: className // TODO: Remove this inline style when we update individual components
    // to set their own color and background-color properties.
    ,
    style: {
      color: 'var(--p-text)'
    }
  }, children);
}

export { CustomProperties, DEFAULT_COLOR_SCHEME, STYLE_SHEET_ID };
